import React from 'react';
import ChoiceQuestionOptionsUI from '../view/ChoiceQuestionOptionsUI';
import {LessonContentChoiceQuestion} from '../../../../../data/models/LessonContent/LessonContentBase';
import {lessonEditorText} from '../../../lessonEditorText';
import BaseOptionsContainer, {
  BaseContainerProps,
} from '../../BaseOptionsContainer';

export default React.memo((props: BaseContainerProps) => (
  <BaseOptionsContainer
    {...props}
    deleteMessage={lessonEditorText.areYouSureDeleteChoiceQuestion}>
    {forwardProps => (
      <ChoiceQuestionOptionsUI
        {...forwardProps}
        entityToEdit={forwardProps.entityToEdit as LessonContentChoiceQuestion}
      />
    )}
  </BaseOptionsContainer>
));
